import {useFormikContext} from 'formik';
import React, {ReactElement} from 'react';
import NxButton, { NxButtonProps } from './NxButton';

/**
 * Formik aware variant of the button that is disabled when form is being submitted or when form is invalid.
 */
export const NxFormikSubmitButton = (props: Omit<NxButtonProps, 'loaded' | 'type'>): ReactElement => {

  const context = useFormikContext();
  return (
    <NxButton {...props}
              loaded={!context.isSubmitting}
              type='submit'
              disabled={props.disabled || context.isSubmitting || !context.isValid}>
      {props.children}
    </NxButton>
  );
}
